/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextlinkinvalid3Inputs */

const en_richtextlinkinvalid3 = /** @type {(inputs: Richtextlinkinvalid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid web address or email address.`)
};

const de_richtextlinkinvalid3 = /** @type {(inputs: Richtextlinkinvalid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib eine gültige Webadresse oder E-Mail-Adresse ein.`)
};

/**
* | output |
* | --- |
* | "Please enter a valid web address or email address." |
*
* @param {Richtextlinkinvalid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextlinkinvalid3 = /** @type {((inputs?: Richtextlinkinvalid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextlinkinvalid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextlinkinvalid3(inputs)
	return de_richtextlinkinvalid3(inputs)
});
export { richtextlinkinvalid3 as "richTextLinkInvalid" }